import React from 'react';
import Grid from '@material-ui/core/Grid';
import Container from '../../../components/dashboard/container';
import { isAeroAdmin } from '../../../components/access';
import { withAuthorization } from '../../../model/Session';
import CityForm from './cityForm';
import * as ROUTES from '../../../constants/routes';

const NewCity = () => (
  <Container backPath={ROUTES.CIUDADES} title="Nueva Ciudad">
    <Grid container spacing={3} justify="center">
      <Grid item xs={12} md={6}>
        <CityForm />
      </Grid>
    </Grid>
  </Container>
);

export default withAuthorization(isAeroAdmin)(NewCity);
